import "./styles.css";
import { config } from "./config.ts";
import { bindTrackedLinks, captureUtm, initAnalytics } from "./analytics.ts";
import { initApplyForm } from "./apply-form.ts";
import { initCounter } from "./counter.ts";
import { initTicker } from "./ticker.ts";

/**
 * EXTERNAL-SITE DIVERGENCE (see SOURCE.md).
 *
 * Replace the application form with a link to where applications are actually
 * taken. Built from DOM nodes rather than innerHTML for the same reason
 * apply-form.ts avoids it: this page's own history is that an innerHTML swap
 * here destroyed applicant input.
 */
function replaceFormWithApplyLink(form: HTMLFormElement): void {
  const block = document.createElement("div");
  block.className = "applyform";

  const note = document.createElement("p");
  note.textContent = "Applications are open on mycgo.ai.";

  const link = document.createElement("a");
  link.className = "nav-cta";
  link.href = config.externalApplyUrl;
  link.rel = "noopener";
  link.textContent = "Claim your early Sweep";

  block.append(note, link);
  form.replaceWith(block);
}

// UTMs first — capture before anything can navigate away from the landing URL.
captureUtm();

// Scroll reveals, lifted from the mock. The reduced-motion guard in styles.css
// forces .reveal visible, so this stays purely additive.
const observer = new IntersectionObserver(
  entries =>
    entries.forEach(e => e.isIntersecting && e.target.classList.add("in")),
  { threshold: 0.12 }
);
document.querySelectorAll(".reveal").forEach(el => observer.observe(el));

// Brief §6: the price-lock line is a config string, rendered from one place.
const priceLock = document.querySelector<HTMLElement>("[data-price-lock]");
if (priceLock) priceLock.textContent = config.priceLockLine;

const form = document.querySelector<HTMLFormElement>("#apply");
if (form) {
  // EXTERNAL-SITE DIVERGENCE (see SOURCE.md): on a deployment with no
  // /api/apply behind it, swap the form for a link to wherever applications
  // are really taken rather than wiring a submit that can only 404.
  if (config.externalApplyUrl) replaceFormWithApplyLink(form);
  else initApplyForm(form);
}

bindTrackedLinks();

// Network-bound work last, so nothing above waits on it.
void initTicker();
void initCounter();

// Pixels after first paint — they are third-party and the brief sets a
// Lighthouse 90+ mobile floor.
if (document.readyState === "complete") initAnalytics();
else window.addEventListener("load", initAnalytics, { once: true });
